import React, { Component } from "react";

import "./style.scss";

class NoPageFound extends Component {
  render() {
    return (
      <div className="no-page-found">
        <span className="no-page-found-title">Coming up in March 2021</span>
      </div>
    );
  }
}

export default NoPageFound;
